export const getBuyersListUrl = "/api/v3/buyer/search";
export const getUsersByBuyerIdUrl = "/api/v3/buyer/:buyerId/users";
export const getBuyerDetailsUrl = "/api/v3/buyer/:buyerId";
export const createBuyerUrl = "/api/v3/buyer/new";
export const updateBuyerUrl = "/api/v3/buyer/:buyerId";
